export const VESSEL_AWARE_ROUTEPARTS = ["map", "details", "reports", "hull", "voyagereports", "cii", "datastorage"];
